import { Component } from "vue-property-decorator";
import { ModelRequeteDto } from "../../../dto/GenApi.iNotPaie.Dto/ModelRequeteDto";
import Vue from "vue";
import $ from "jquery";
import { EventBus } from "../../Controls/EventBus";
import EventConstants from "../../Controls/EventConstants";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalRequeteur extends Vue {
	public isLoading = false;
	private model?: ModelRequeteDto = {
		Id: 0,
		Name: "",
		Style: {
			CanDelete: false,
			CircleColor: "",
			CircleIcone: ""
		},
		EstArchive: false,
		Descript: "",
		Filtres: [],
		Orders: [],
		Items: []
	};

	public Init(model: ModelRequeteDto): void {
		this.model = model;
		this.isLoading = false;
	}

	private Submit(): void {
		this.isLoading = true;
		NotificationServiceInstance.SendInformation(((this.model!.Id == 0) ? "Création" : "Modification") + " du modèle en cours..");

		if (this.model!.Id == 0) {
			ServicesFactoryInstance.ModelRequeteService.addModel(this.model!, () => {
				NotificationServiceInstance.SendSuccess("Modèle créé !");
				this.CloseTab();
			});
		} else {
			ServicesFactoryInstance.ModelRequeteService.updateModel(this.model!, () => {
				NotificationServiceInstance.SendSuccess("Modèle modifié !");
				this.CloseTab();
			});
		}
	}

	private Close(): void {
		$("#modalRequeteur").modal("hide");
	}

	private CloseTab(): void {
		this.Close();
		EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
	}
}



// WEBPACK FOOTER //
// ./src/components/requeteurModifieur/modalRequeteur/modalRequeteur.ts